import { Request } from '../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../httpClient/serverApi/types/IGetItemsResult';
import { IBackgroundJob } from './IBackgroundJob';

export interface IGetBackgroundJobsResult extends IGetItemsResult {
  backgroundJobs: IBackgroundJob[];
}

export class GetBackgroundJobsRequest extends Request<IGetItemsParams, IGetBackgroundJobsResult> {
  constructor(params: IGetItemsParams) {
    super('getBackgroundJobs', params);
  }
}
